<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row align-items-center justify-content-lg-between justify-content-center">
                <div class="col-lg-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="https://www.appsa.co.uk">Appsa</a> 
                    </div>
                </div>
                <div class="col-lg-6">
                    <ul class="nav nav-footer justify-content-end flex-sm-row flex-column">
                        <li class="nav-item">
                            <a href="#/contact" class="nav-link">Contact</a>
                        </li>
                        <li class="nav-item">
                            <a href="#/privacy" class="nav-link">Privacy</a>
                        </li>
                        <li class="nav-item">
                            <a href="#/terms_of_use"
                               class="nav-link">Terms of use</a>
                        </li>
                    </ul>
<modal :show.sync="modals.modal2"
               gradient="primary"
               modal-classes="modal-primary modal-dialog-centered">
            <h6 slot="header" class="modal-title" id="modal-title-notification">Our commitment to GDPR</h6>

            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <p>
			We use cookies to offer you a better browsing experience and analyze site trafic.
			Read about how we use cookies in Privacy Policy Notice.
		</p>
            </div>

            <template slot="footer">
                <base-button type="success" @click="setCookies()" >Accpet cookies</base-button>
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="goToPrivacy()">
			No, give More information
                </base-button>
            </template>
        </modal>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import Modal from '@/components/Modal.vue';
export default {
  name: 'app-footer',
  components: {
	Modal,
	},
  data() {
    return {
	modals: {
		modal2: true,
	},
      year: new Date().getFullYear()
    }
  },
	methods: {
		checkCookies: function() {
			if (window.document.cookie) {
				var cookie_props = window.document.cookie.split(';');
				for ( var i = 0; i< cookie_props.length; i++) {
					if ( cookie_props[i].trim().indexOf('appsa=') >= 0 ){
						this.setCookies(cookie_props[i].trim());
						break;
					}
				}
				this.setCookies(null);
				this.modals.modal2 = false;
			}		
		},
		setCookies: function(cookie) {
			var old_cookie = cookie || null;
			
			// Call Server to update cookie
			var d = new Date();
			d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
			var new_cookie = "appsa="+ Math.round(Math.random()*1000000) +"; expires=" + d.toUTCString();

			window.document.cookie = new_cookie;
			this.modals.modal2 = false;
		},
		goToPrivacy: function() {
			this.$router.push({name: "privacy"});
			this.modals.modal2 = false;
		},
		callCookieServer: function() {

		},
	},
	mounted() {
		this.checkCookies();	
	}
};
</script>
<style>
</style>
